import type { FunctionComponent } from "react"

import { Text } from "@jobteaser/spark/components/Text"
import { Link } from "@jobteaser/ui-kit/components/Link/Link"

import { CompanyLogo } from "@/modules/companies/client/components/CompanyLogo/CompanyLogo"

import styles from "./CompanyItem.module.css"

export type CompanyItemType = {
  name: string
  description: string | null
  logoUrl: string
  permalink: string | null
}

export const CompanyItem: FunctionComponent<CompanyItemType> = ({ name, description, logoUrl, permalink }) => {
  const Tag = permalink ? Link : "div"

  const attributes = {
    ...(permalink && { href: permalink }),
  }

  return (
    <Tag {...attributes} className={styles.companyItem__link}>
      <CompanyLogo logoUrl={logoUrl} />
      <div>
        <Text variant="body1" weight="semiBold">
          {name}
        </Text>
        {description && (
          <Text variant="body2" className={styles.companyItem__description}>
            {description}
          </Text>
        )}
      </div>
    </Tag>
  )
}
